import type { PocInputValidity } from 'commons/types';
import { CleaningProperties } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-device-configuration-status-tracking/settings-device-configuration-status-tracking.model';
import {
    INVALID_STATUS_TRACKING_STATE,
    STATUS_TRACKING_TRANSLATION_PREFIX,
    VALID_STATUS_TRACKING_STATE,
} from '../../constants';
import { MIN_CLEANING_HOURS } from './cleaning-status-tracking-card.constants';

export type CleaningThresholdsError = 'minimum-one-hour' | 'warning-lower-than-overdue' | 'whole-hours-only';

export const CLEANING_THRESHOLDS_ERROR_MESSAGE_KEYS: Record<CleaningThresholdsError, string> = {
    'minimum-one-hour': `${STATUS_TRACKING_TRANSLATION_PREFIX}.cleaning.validity.minimumOneHour`,
    'warning-lower-than-overdue': `${STATUS_TRACKING_TRANSLATION_PREFIX}.cleaning.validity.warningLowerThanAlarm`,
    'whole-hours-only': `${STATUS_TRACKING_TRANSLATION_PREFIX}.cleaning.validity.wholeHoursOnly`,
};

export const validateCleaningThresholds = ({
    warningHours,
    overdueHours,
}: Pick<CleaningProperties, 'warningHours' | 'overdueHours'>): CleaningThresholdsError | undefined => {
    if (!Number.isInteger(warningHours) || !Number.isInteger(overdueHours)) {
        return 'whole-hours-only';
    }
    if (warningHours < MIN_CLEANING_HOURS || overdueHours < MIN_CLEANING_HOURS) {
        return 'minimum-one-hour';
    }
    if (warningHours >= overdueHours) {
        return 'warning-lower-than-overdue';
    }
    return undefined;
};

export const toCleaningThresholdsValidity = (error?: CleaningThresholdsError): PocInputValidity =>
    error ? INVALID_STATUS_TRACKING_STATE : VALID_STATUS_TRACKING_STATE;
